import React, { FC } from 'react'

import customImageComponent from '../../common/CustomImageComponent'
import { getUserFullName } from '../../../helpers/helpers'

import { IUserInterface } from '../../../models/users/user.interface'

interface RiderInfoPanelProps {
  countClasses: number
  countQualifyClasses: number
  user: IUserInterface
}

export const RiderInfoPanel: FC<RiderInfoPanelProps> = ({
  countClasses,
  countQualifyClasses,
  user,
}) => {
  return (
    <div className="flex justify-between items-center gap-2 mb-6 pb-6 border-b border-b-black/10">
      <div className="flex gap-2">
        {customImageComponent(
          user?.userProfilePicture,
          getUserFullName(user),
          '!w-[45px] !min-w-[45px] !h-[45px] rounded-md border border-black/10'
        )}
        <div className="flex flex-col justify-between">
          <div className="text-xs opacity-50">Rider</div>
          <span>{getUserFullName(user)}</span>
        </div>
      </div>
      <div className="flex gap-2">
        <div className="text-right flex flex-col justify-between">
          <div className="text-xs opacity-50">Classes • Bonus fees</div>
          <span>
            {countClasses} • {countQualifyClasses}
          </span>
        </div>
        <div className="flex items-center justify-center w-[45px] min-w-[45px] h-[45px] rounded-md bg-SeabiscuitMainThemeColor/5">
          <img src="/assets/og_icons/Prize-2.svg" className="w-6" alt="" />
        </div>
      </div>
    </div>
  )
}
